export default __webpack_public_path__ + "static/media/3_005.3101616f.png";